import script from "./compActorsStatsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./compActorsStatsPanel.vue?vue&type=script&setup=true&lang=js"

import "./compActorsStatsPanel.vue?vue&type=style&index=0&id=18b6a0f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b6a0f0"]])

export default __exports__